import { render } from "./PermissionAction.vue?vue&type=template&id=061bda0a&scoped=true"
import script from "./PermissionAction.vue?vue&type=script&lang=js"
export * from "./PermissionAction.vue?vue&type=script&lang=js"

import "./PermissionAction.vue?vue&type=style&index=0&id=061bda0a&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061bda0a"]])

export default __exports__